export default function ValidateInputRequired({
  validList,
  elementType,
  children,
}) {
  return validList.includes(elementType) ? children : null
}
